import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';


@withRouter
@inject('lineStore', 'routingStore')
@observer
class Schedule extends Component {
  selectItem = () => {
    this.props.history.push(`/${this.props.lineStore.menu.mode}/schedule`);
    // this.props.lineStore.toggleSchedule(true);
  }

  render() {
    return (
      <div className="live-schedule-show-cont">
        {/* <div className="live-schedule-show">
          <span className="live-sport-menu-item-ico live-shedule-show-ico f-s-ico-calendar"/>
          <button
            className="live-schedule-show-button"
            onClick={this.selectItem}
          >
            Анонс Live
          </button>
        </div> */}
      </div>
    );
  }
}

export default Schedule;



// WEBPACK FOOTER //
// ./src/components/liveMenu/schedule.jsx